import React, { useEffect, useRef } from 'react';
import { Col, Container, Row } from "react-bootstrap";
import { useAppSelector } from "../../../app/hooks";
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

const ThreejsVisualizer = () => {
  const resize = useAppSelector(state => state.navbar.resize);
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    // Scene Setup
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    const renderer = new THREE.WebGLRenderer({ canvas: canvasRef.current });
    if (!canvasRef.current) return; // Ensure the canvas exists
    renderer.setSize(window.innerWidth, window.innerHeight);
    camera.position.z = 5;
    camera.position.set(0, 2, 5);

    // Add Light
    const light = new THREE.AmbientLight(0xffffff, 0.8);
    scene.add(light);

    // Add Cube
    const geometry = new THREE.BoxGeometry();
    const material = new THREE.MeshStandardMaterial({ color: 0x00ff00 });
    const cube = new THREE.Mesh(geometry, material);
    scene.add(cube);

    // Orbit Controls
    const controls = new OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true;

    // Animation Loop
    const animate = () => {
      requestAnimationFrame(animate);
      cube.rotation.x += 0.01;
      cube.rotation.y += 0.01;
      controls.update();
      renderer.render(scene, camera);
    };
    animate();

    // Handle Resizing
    const handleResize = () => {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    };
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      renderer.dispose();
    };
  }, []);

  return (
    <Container
      className="about-wrapper"
      fluid
      style={{
        marginLeft: resize ? "0" : "20rem",
        width: resize ? "" : "calc(100vw - 20rem)",
        backgroundColor: "rgb(8, 13, 19)",
        height: "100vh",
        paddingBottom: "10rem",
        paddingRight: "0",
        paddingLeft: "0",
      }}
    >
      <Row className="flex-lg-row" lg={12}>
        <Col xs={12} sm={12} md={12} lg={12} className="d-flex">
          <div className="title fs-4 text-success text-start m-4 p-4 border border-light rounded w-100">
            <Row>
              <Col xs={12} sm={12} md={12} lg={8} xl={8} className="order-lg-2">
                <h1 className="text-light fs-2">3D Visualizer</h1>
                <h3 className="fs-4">
                  This is a 3D visualizer that is interactive. It can be used to display data in a more user-friendly way.
                </h3>
              </Col>
            </Row>
          </div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={12} className="d-flex justify-content-center mt-4">
          <div
            style={{
              width: '100%',
              height: '500px',
              overflow: 'hidden',
              border: '1px solid #ccc',
              position: 'relative',
            }}
          >
            <canvas ref={canvasRef} style={{ display: 'block' }} />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ThreejsVisualizer;
